import * as React from "react";
import { Box, CPHrBreak, CPText } from "shared/components/base";
import CPModal from "shared/components/shared/CPModal/CPModal";

interface FileStorageConfigHelpModalProps {
  open: boolean;
  onClose: () => void;
}

const mono: React.CSSProperties = {
  fontFamily: "monospace",
  fontSize: 11,
  wordBreak: "break-all",
};

const rows: [string, boolean, string, string][] = [
  [
    "Storage Provider",
    false,
    "Where the file is stored.",
    "AZURE_BLOB, SHAREPOINT, LOCAL, URL",
  ],
  [
    "Storage Key",
    false,
    "The blob name, relative file path, or SharePoint document path. Not used for URL provider.",
    "e.g. reports/annual-report-2025.pdf",
  ],
  [
    "File Name",
    true,
    "The file name presented to the user when downloading. Required for non-URL providers.",
    "e.g. annual-report-2025.pdf",
  ],
  [
    "MIME Type",
    false,
    "The content type of the file. Used to set the correct Content-Type header on download.",
    "e.g. application/pdf, application/vnd.ms-excel",
  ],
  [
    "Download URL",
    true,
    "A direct download URL or share link. Required when Storage Provider is URL.",
    "e.g. https://example.sharepoint.com/…",
  ],
];

const FileStorageConfigHelpModal: React.FC<FileStorageConfigHelpModalProps> = ({
  open,
  onClose,
}) => {
  return (
    <CPModal
      title="File Configuration"
      open={open}
      onClose={onClose}
      width={780}
    >
      <Box flexDirection="column" spacing={12}>
        <CPText>
          Controls how the file is stored and served to users on download.
        </CPText>

        <table
          style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}
        >
          <thead>
            <tr style={{ background: "#f0f4f8" }}>
              {["Field", "Required", "Description", "Example"].map((h) => (
                <th
                  key={h}
                  style={{
                    padding: "6px 10px",
                    border: "1px solid #dee2e6",
                    textAlign: "left",
                    fontWeight: 600,
                  }}
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map(([field, required, desc, example], i) => (
              <tr
                key={field}
                style={{ background: i % 2 === 0 ? "#fff" : "#fafafa" }}
              >
                <td
                  style={{
                    padding: "6px 10px",
                    border: "1px solid #dee2e6",
                    whiteSpace: "nowrap",
                    fontWeight: 500,
                  }}
                >
                  {field}
                  {required && <span style={{ color: "#c00" }}> *</span>}
                </td>
                <td
                  style={{
                    padding: "6px 10px",
                    border: "1px solid #dee2e6",
                    textAlign: "center",
                  }}
                >
                  {required ? "Yes" : "No"}
                </td>
                <td
                  style={{ padding: "6px 10px", border: "1px solid #dee2e6" }}
                >
                  {desc}
                </td>
                <td
                  style={{
                    padding: "6px 10px",
                    border: "1px solid #dee2e6",
                    ...mono,
                  }}
                >
                  {example}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <CPHrBreak />

        <Box
          style={{
            background: "#e8f4fd",
            border: "1px solid #90caf9",
            borderRadius: 4,
            padding: "8px 12px",
          }}
          flexDirection="column"
          spacing={4}
        >
          <CPText bold fontSize="13px">
            URL Provider
          </CPText>
          <CPText textStyle="caption" style={{ color: "#555" }}>
            When the Storage Provider is set to URL, only the Download URL field
            is required. Storage Key, File Name, and MIME Type are hidden and
            not used.
          </CPText>
        </Box>
      </Box>
    </CPModal>
  );
};

export default FileStorageConfigHelpModal;
